module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-gray@3x-e3c049be190ad756a2c75e725ebeb0ec.png";